var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "160",
      "height": "142",
      "viewBox": "0 0 180 160",
      "fill": "none",
      "aria-hidden": "true"
    }
  }, [_c('ellipse', {
    attrs: {
      "cx": "90",
      "cy": "85",
      "rx": "80",
      "ry": "69",
      "fill": "#EEF0FF"
    }
  }), _c('rect', {
    attrs: {
      "x": "51",
      "y": "34",
      "width": "108",
      "height": "83",
      "rx": "9",
      "fill": "white",
      "stroke": "#C8C1EA",
      "stroke-width": "3"
    }
  }), _c('path', {
    attrs: {
      "d": "M68 49v50h75",
      "stroke": "#AAA1E5",
      "stroke-width": "3",
      "stroke-linecap": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "m77 86 17-15 18 6 22-20",
      "stroke": "#8B80D5",
      "stroke-width": "4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-dasharray": "4 7"
    }
  }), _c('circle', {
    attrs: {
      "cx": "134",
      "cy": "57",
      "r": "5",
      "fill": "#4F35BC"
    }
  }), _c('rect', {
    attrs: {
      "x": "23",
      "y": "95",
      "width": "64",
      "height": "43",
      "rx": "5",
      "fill": "#E6C79A"
    }
  }), _c('path', {
    attrs: {
      "d": "M23 104h64M49 95v18h12V95",
      "stroke": "#C49A64",
      "stroke-width": "3"
    }
  }), _c('rect', {
    attrs: {
      "x": "35",
      "y": "66",
      "width": "42",
      "height": "29",
      "rx": "4",
      "fill": "#F4DAB3"
    }
  }), _c('path', {
    attrs: {
      "d": "M51 66v13h10V66",
      "fill": "#D9B482"
    }
  }), _c('path', {
    attrs: {
      "d": "m25 42 3 7 7 3-7 3-3 7-3-7-7-3 7-3Z",
      "fill": "#AAA1E5"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }